import { PartialRecord } from "../types/partial-record";
import { Pages, Routes } from "../types/routes";

export const PageRoutes: Readonly<PartialRecord<string, string>> = {
  [Pages.Home]: Routes.Home,
  [Pages.Contact]: Routes.Contact,
  [Pages.Treatments]: Routes.Treatments,
};
